/* eslint-disable no-unused-vars */
import React, { Fragment } from 'react';
import Loadable from 'react-loadable';
import CoreException from './Error';
import { Loading } from '../components/Loading';

const getComponent = loader => ({
  loader,
  loading: props => {
    if (props.error) {
      return <CoreException desc={props.error.toString()} />;
    } else if (props.timedOut) {
      return (
        <CoreException
          desc="页面加载超时"
          onBtnClick={() => {
            window.location.reload();
          }}
          btnText="点我重试"
        />
      );
    } else if (props.pastDelay) {
      return <Loading />;
    } 
    return null;
    
  }
});
const env = process.env.NODE_ENV || 'development';
const devMode = env === 'development';
const routes = [
 ...(devMode ? [{
    path: '/h5_fe_tool/html/',
    title: '宝宝树工具',
    exact: true,
    strict: true, // 为了使用serviceWorker，这里必须为true，因为如果使用/h5_fe_tool/html 这个路径sw不会生效
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "DemoIndex" */ 'pages/Demo/pages/Index/index.jsx'
      )
      )
    )
  }] : []),
  {
    path: '/h5_fe_tool/html/fetal_movement/index',
    title: '数胎动首页',
    toolName: '数胎动',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "FetalMovementIndex" */ 'pages/FetalMovement/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/fetal_movement/list',
    title: '数胎动列表页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "FetalMovementRecordList" */ 'pages/FetalMovement/pages/RecordList/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/fetal_movement/result',
    title: '数胎动结果页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "FetalMovementResult" */ 'pages/FetalMovement/pages/Result/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/fetal_movement/shortcut/index',
    title: '数胎动',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "FetalMovementShortcut" */ 'pages/FetalMovement/pages/Shortcut/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/mika_desktop/shortcut/index',
    title: '米卡桌面快捷入口',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "MikaDesktopEntranceShortcut" */ 'pages/MikaDesktopEntrance/pages/Shortcut/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/weight/index',
    title: '胎儿估重器',
    toolName: '胎儿估重器',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "WeightIndex" */ 'pages/Weight/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/weight/result',
    title: '胎儿估重器',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "WeightResult" */ 'pages/Weight/pages/Result/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/weight/edit',
    title: '胎儿估重器',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "WeightEdit" */ 'pages/Weight/pages/Edit/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/cando/index',
    title: '能不能做首页',
    toolName: '能不能做',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CandoIndex" */ 'pages/Cando/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/cando/category',
    title: '能不能做黑白榜',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CandoCategory" */ 'pages/Cando/pages/Category/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/cando/detail',
    title: '能不能做详情页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CandoDetail" */ 'pages/Cando/pages/Detail/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/cando/list',
    title: '能不能做列表页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CandoList" */ 'pages/Cando/pages/List/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/cando/search',
    title: '能不能做搜索',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CandoSearch" */ 'pages/Cando/pages/Search/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/goodluck/index',
    title: '每日好运',
    toolName: '每日好运',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "goodluckIndex" */ 'pages/Goodluck/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/goodluck/mysign',
    title: '每日好运-我的签到',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "goodluckMysign" */ 'pages/Goodluck/pages/Mysign/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/goodluck/calendar',
    title: '每日好运',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "goodluckCalendar" */ 'pages/Goodluck/pages/Calendar/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/goodluck/setting',
    title: '每日好运-设置',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "goodluckSetting" */ 'pages/Goodluck/pages/Setting/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/caneat/detail',
    title: '能不能吃详情页',
    toolName: '能不能吃',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CaneatDetail" */ 'pages/Caneat/pages/Detail/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/caneat/search',
    title: '能不能吃搜索',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CaneatSearch" */ 'pages/Caneat/pages/Search/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/caneat/list',
    title: '能不能吃列表页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CaneatList" */ 'pages/Caneat/pages/List/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/caneat/category',
    title: '能不能吃黑白榜',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CaneatCategory" */ 'pages/Caneat/pages/Category/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/caneat/index',
    title: '能不能吃首页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "CaneatIndex" */ 'pages/Caneat/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/recipes/index',
    title: '食谱工具首页',
    toolName: '食谱',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "RecipesIndex" */ 'pages/Recipes/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/recipes/search',
    title: '食谱搜索',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "RecipesSearch" */ 'pages/Recipes/pages/Search/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/recipes/effectdetail',
    title: '食谱聚合页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "RecipesEffectDetail" */ 'pages/Recipes/pages/EffectDetail/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/recipes/proposaldetail',
    title: '食谱建议',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ProposalDetail" */ 'pages/Recipes/pages/ProposalDetail/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/contractions/index',
    title: '数宫缩',
    toolName: '数宫缩',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ContractionsIndex" */ 'pages/Contractions/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/contractions/list',
    title: '宫缩记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ContractionsList" */ 'pages/Contractions/pages/List/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/contractions/info',
    title: '宫缩小知识',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "ContractionsInfo" */ 'pages/Contractions/pages/Info/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/feedingrecords/statistichome',
    title: '宝宝统计图表',
    toolName: '喂养记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "feedingrecordsStatisticHome" */ 'pages/FeedingRecords/pages/StatisticHomes'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/feedingrecords/dailyroutine',
    title: '宝宝日常生活规律图',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "feedingrecordsDailyRoutine" */ 'pages/FeedingRecords/pages/DailyRoutine'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/feedingrecords/statistic',
    title: '喂养记录统计',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "feedingrecordsStatistic" */ 'pages/FeedingRecords/pages/Statistic'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/feedingrecords/forheartrecord',
    title: '喂养记录-随心记',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "feedingrecordsForhearthecord" */ 'pages/FeedingRecords/pages/ForHeartRecord'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/feedingrecords/pampers',
    title: 'pampers',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "feedingrecordsPampers" */ 'pages/FeedingRecords/pages/Pampers'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/feedingrecords/detail',
    title: '喂养',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "feedingrecordsDetail" */ 'pages/FeedingRecords/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/futureforest/index',
    title: '未来森林',
    toolName: '未来森林',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "futureforestIndex" */ 'pages/FutureForest/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/begininaminute',
    title: '儿童成长测评',
    toolName: '即将开始测评',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "begininaminute" */ 'pages/GrowUpEvaluation/pages/BeginInAMinute/index.js'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/index',
    title: '儿童成长测评',
    toolName: '儿童成长测评',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationIndex" */ 'pages/GrowUpEvaluation/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/question',
    title: '儿童成长测评',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationQuestion" */ 'pages/GrowUpEvaluation/pages/Question/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/collect',
    title: '儿童成长测评',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationCollect" */ 'pages/GrowUpEvaluation/pages/Collect/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/collectagain',
    title: '儿童成长测评',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationCollectAgain" */ 'pages/GrowUpEvaluation/pages/CollectAgain/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/historyOrders',
    title: '历史订单',
    toolName: '历史订单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationHistoryOrders" */ 'pages/GrowUpEvaluation/pages/HistoryOrders/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/paystatus',
    title: '支付状态',
    toolName: '支付状态',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationPayStatus" */ 'pages/GrowUpEvaluation/pages/Result/component/PayStatus/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/babyswitch',
    title: '切换宝宝',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationBabySwitch" */ 'pages/GrowUpEvaluation/pages/BabySwitch/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/result',
    title: '成长评测结果入口页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationResult" */ 'pages/GrowUpEvaluation/pages/Result/result.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/result/guide',
    title: '成长评测阅读指南',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationResultGuid" */ 'pages/GrowUpEvaluation/pages/Result/guide.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/result/index',
    title: '成长评测结果页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationResultIndex" */ 'pages/GrowUpEvaluation/pages/Result/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/share',
    title: '成长评测分享页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationResultShare" */ 'pages/GrowUpEvaluation/pages/Result/share.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/history',
    title: '成长评测历史记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationHistoryIndex" */ 'pages/GrowUpEvaluation/pages/History/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupevaluation/about_evaluation',
    title: '关于成长测评',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpEvaluationAboutEvaluation" */ 'pages/GrowUpEvaluation/pages/AboutEvaluation/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregmovement/redirect',
    title: '备孕运动',
    toolName: '备孕运动',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregMovementRedirect" */ 'pages/PregMovement/pages/Redirect'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregmovement/index',
    title: '',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregMovementIndex" */ 'pages/PregMovement/pages/Index/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregmovement/detail',
    title: '',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregMovementDetail" */ 'pages/PregMovement/pages/Detail/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregmovement/history',
    title: '运动计划历史记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregMovementHistory" */ 'pages/PregMovement/pages/History/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregmovement/midfield',
    title: '运动计划定制过渡页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregMovementMidfield" */ 'pages/PregMovement/pages/Midfield/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregmovement/myplan',
    title: '运动计划我的计划',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregMovementMyplan" */ 'pages/PregMovement/pages/MyPlan/index.jsx'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheck/index',
    title: '孕前检查单列表页',
    toolName: '孕前检查单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckIndex" */ 'pages/PrePregCheck/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheck/detail',
    title: '孕前检查单详情页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckDetail" */ 'pages/PrePregCheck/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheck/edit',
    title: '添加孕前检查单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckEdit" */ 'pages/PrePregCheck/pages/Edit'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheck/explain',
    title: '孕前检查单免责说明',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckExplain" */ 'pages/PrePregCheck/pages/Explain'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/dictionary/index',
    title: '孕育词典',
    toolName: '孕育词典',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "DictionaryIndex" */ 'pages/Dictionary/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupmv/share',
    title: '喜报',
    toolName: '喜报',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpMVShare" */ 'pages/GrowUpMV/pages/Share'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/growupmv/wishlist',
    title: '收到的祝福',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "GrowUpMVWishList" */ 'pages/GrowUpMV/pages/WishList'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregevaluation/index',
    title: '备孕测评首页',
    toolName: '备孕测评',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregEvaluationIndex" */ 'pages/PrePregEvaluation/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregevaluation/question',
    title: '备孕测评页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregEvaluationQuestion" */ 'pages/PrePregEvaluation/pages/Question'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregevaluation/result',
    title: '备孕测评结果页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregEvaluationResult" */ 'pages/PrePregEvaluation/pages/Result'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregposture/index',
    title: '好孕姿势',
    toolName: '好孕姿势',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregPostureIndex" */ 'pages/PrePregPosture/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregposture/detail',
    title: '好孕姿势',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregPostureDetail" */ 'pages/PrePregPosture/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregguide/index',
    title: '备孕指南首页',
    toolName: '备孕指南',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregGuideIndex" */ 'pages/PrePregGuide/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregguide/detail',
    title: '备孕指南详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregGuideDetail" */ 'pages/PrePregGuide/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/preprehandbook/index',
    title: '准爸爸手册',
    toolName: '准爸手册',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregDadsHandBookIndex" */ 'pages/PrePregDadsHandBook/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/preprehandbook/detail',
    title: '准爸爸手册详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregDadsHandBookDetail" */ 'pages/PrePregDadsHandBook/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/index',
    title: '健康分析',
    toolName: '经期记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisIndex" */ 'pages/PeriodRecords/pages/AnalysisIndex'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/symptom/index',
    title: '症状分析',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisSymptomIndex" */ 'pages/PeriodRecords/pages/Symptom/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/symptom/list',
    title: '症状分析列表',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisSymptomList" */ 'pages/PeriodRecords/pages/Symptom/List'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/habit/index',
    title: '习惯分析',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisHabitIndex" */ 'pages/PeriodRecords/pages/Habit/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/habit/list',
    title: '习惯分析列表',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisHabitList" */ 'pages/PeriodRecords/pages/Habit/List'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/menses/index',
    title: '月经分析',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisMensesIndex" */ 'pages/PeriodRecords/pages/MensesIndex'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/menses/list',
    title: '所有记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisMensesIndexList" */ 'pages/PeriodRecords/pages/MensesIndex/List'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/temperature/index',
    title: '体温分析',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisTemperatureIndex" */ 'pages/PeriodRecords/pages/Temperature/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/temperature/list',
    title: '体温分析列表',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisTemperatureList" */ 'pages/PeriodRecords/pages/Temperature/List'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/weight/index',
    title: '体重分析',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisWeightIndex" */ 'pages/PeriodRecords/pages/Weight/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/weight/list',
    title: '体重分析列表',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisWeightList" */ 'pages/PeriodRecords/pages/Weight/List'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/preg-report/index',
    title: '备孕报告',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisPrePregReport" */ 'pages/PeriodRecords/pages/PrePregReport'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/love/index',
    title: '爱爱分析',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisLoveIndex" */ 'pages/PeriodRecords/pages/LoveIndex/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/analysis/love/list',
    title: '爱爱分析列表',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsAnalysisLoveList" */ 'pages/PeriodRecords/pages/LoveIndex/List'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/explanation',
    title: '名词解释',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsExplanation" */ 'pages/PeriodRecords/pages/Explanation/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/explanation/modal',
    title: '名词解释',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsExplanationModal" */ 'pages/PeriodRecords/pages/Explanation/Modal'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/periodrecords/babysizeinfo',
    title: '宝宝身高体重成长记录帮助页',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PeriodRecordsBabySizeInfo" */ 'pages/PeriodRecords/pages/BabySizeInfo'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/picturebookmuseum/index',
    title: '绘本馆',
    toolName: '绘本馆',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PictureBookMuseumIndex" */ 'pages/PictureBookMuseum/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/picturebookmuseum/list',
    title: '绘本馆',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PictureBookMuseumList" */ 'pages/PictureBookMuseum/pages/List'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/picturebookmuseum/filter',
    title: '绘本馆',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PictureBookMuseumFilter" */ 'pages/PictureBookMuseum/pages/Filter'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/picturebookmuseum/favor',
    title: '绘本馆',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PictureBookMuseumFavor" */ 'pages/PictureBookMuseum/pages/Favor'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/picturebookmuseum/search',
    title: '绘本馆',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PictureBookMuseumSearch" */ 'pages/PictureBookMuseum/pages/Search'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/picturebookmuseum/detail',
    title: '绘本详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PictureBookMuseumDetail" */ 'pages/PictureBookMuseum/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/picturebookmuseum/outerdetail',
    title: '绘本详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PictureBookMuseumDetailouter" */ 'pages/PictureBookMuseum/pages/Detail/outer'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/picturebookmuseum/comment_detail',
    title: '评论详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PictureBookMuseumCommentDetail" */ 'pages/PictureBookMuseum/pages/Detail/CommentDetail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/vaccineschedule/detail',
    title: '疫苗时间表',
    toolName: '疫苗时间表',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "VaccineScheduleDetail" */ 'pages/VaccineSchedule/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/testtube/index',
    title: '试管助手',
    toolName: '试管助手',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "TestTubeIndex" */ 'pages/TestTube/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/testhealth/index',
    title: '测测健康',
    toolName: '测测健康',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "TestHealthIndex" */ 'pages/TestHealth/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/testhealth/subject',
    title: '测测健康',
    toolName: '测测健康',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "TestHealthSubject" */ 'pages/TestHealth/pages/Subject'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/testhealth/healthResult',
    title: '测测健康',
    toolName: '测测健康',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "TestHealthResult" */ 'pages/TestHealth/pages/HealthResult'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/hospital_doc_assistant/index',
    title: '建档助手',
    toolName: '建档助手',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "HospitalDocAssistantIndex" */ 'pages/HospitalDocAssistant/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/hospital_doc_assistant/detail',
    title: '建档助手',
    toolName: '建档助手',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "HospitalDocAssistantDetail" */ 'pages/HospitalDocAssistant/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/hospital_doc_assistant/hospital_info',
    title: '医院详情',
    toolName: '医院详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "HospitalDocAssistantHospitalInfo" */ 'pages/HospitalDocAssistant/pages/HospitalInfo'
      )
      )
    )
  },
    // ===== PrePregCheckSchedule 路由start =====
  {
    path: '/h5_fe_tool/html/prepregcheckschedule/index',
    title: '产检时间表',
    toolName: '产检时间表',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckScheduleIndex" */ 'pages/PrePregCheckScheduleV2/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheckschedule/detail',
    title: '产检详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckScheduleDetail" */ 'pages/PrePregCheckScheduleV2/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheckschedule/list',
    title: '我的产检单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckScheduleList" */ 'pages/PrePregCheckScheduleV2/pages/List'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheckschedule/items/index',
    title: '产检项目列表',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckScheduleItemsIndex" */ 'pages/PrePregCheckScheduleV2/pages/Items/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheckschedule/items/detail',
    title: '产检项目详情',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckScheduleItemsDetail" */ 'pages/PrePregCheckScheduleV2/pages/Items/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheckschedule/edit/index',
    title: '添加产检',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckScheduleEditIndex" */ 'pages/PrePregCheckScheduleV2/pages/Edit/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheckschedule/edit/name',
    title: '修改产检名称',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckScheduleEditIndexName" */ 'pages/PrePregCheckScheduleV2/pages/Edit/Name'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/prepregcheckschedule/smart_interpretation',
    title: '智能解读',
    toolName: '智能解读',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrePregCheckScheduleSmartInt" */ 'pages/PrePregCheckScheduleV2/pages/SmartInt'
      )
      )
    )
  },
  // ===== PrePregCheckSchedule 路由end =====
  {
    path: '/h5_fe_tool/html/bscanfrom/index',
    title: '看懂B超单',
    toolName: '看懂B超单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "BScanFromIndex" */ 'pages/BScanFrom/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/bscanfrom/detail',
    title: '看懂B超单',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "BScanFromDetail" */ 'pages/BScanFrom/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregdiary/print/tasklist',
    title: '时光券',
    toolName: '小时光',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregDiaryPrintNewtasklist" */ 'pages/PregDiary/pages/Print/NewTaskList'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregdiary/print/newtasklist',
    title: '时光券',
    toolName: '小时光',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregDiaryPrintNewCopytasklist" */ 'pages/PregDiary/pages/Print/NewTaskList'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregdiary/print/detailed',
    title: '时光券明细',
    toolName: '小时光',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PrintUseDetailed" */ 'pages/PregDiary/pages/Print/Detailed'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregdiary/print/details',
    title: '树钻定制打印详情页',
    toolName: '小时光',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregDiaryPrintDetails" */ 'pages/PregDiary/pages/Print/Details'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregdiary/print/album',
    title: '定制相册',
    toolName: '小时光',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregDiaryPrintAlbum" */ 'pages/PregDiary/pages/Print/Album'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/pregdiary/print/yinge/preview',
    title: '商品确认',
    toolName: '小时光',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PregDiaryPrintYinGePreview" */ 'pages/PregDiary/pages/Print/YinGePreview'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/predeliverypackage/index',
    title: '待产包',
    toolName: '待产包',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PredeliveryPackageIndex" */ 'pages/PredeliveryPackage/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/predeliverypackage/detail',
    title: '待产包',
    toolName: '待产包',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PredeliveryPackageDetail" */ 'pages/PredeliveryPackage/pages/Detail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/predeliverypackage/addlist',
    title: '添加物品',
    toolName: '待产包',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PredeliveryPackageAddList" */ 'pages/PredeliveryPackage/pages/AddList'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/predeliverypackage/customize',
    title: '自定义物品',
    toolName: '待产包',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "PredeliveryPackageCustomize" */ 'pages/PredeliveryPackage/pages/Customize'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/hcg/index',
    title: 'hcg记录首页',
    toolName: 'hcg记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "HcgToolIndex" */ 'pages/Hcg/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/hcg/introduce',
    title: 'hcg介绍',
    toolName: 'hcg记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "HcgToolIntroduce" */ 'pages/Hcg/pages/Introduce'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/hcg/input',
    title: 'hcg添加记录',
    toolName: 'hcg记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "HcgToolInputInfo" */ 'pages/Hcg/pages/InputInfo'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/hcg/history',
    title: '我的记录',
    toolName: 'hcg记录',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "HcgToolHistory" */ 'pages/Hcg/pages/HistoryPage'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/wishingtree/index',
    title: '祈福',
    toolName: '祈福',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "WishingTreeIndex" */ 'pages/WishingTree/pages/Index'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/wishingtree/luckyrecord',
    title: '福气值记录',
    toolName: '祈福',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "WishingTreeLuckyRecordPage" */ 'pages/WishingTree/pages/LuckyRecord'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/wishingtree/wishingcardlist',
    title: '心愿卡列表',
    toolName: '祈福',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "WishingTreeWishCardListPage" */ 'pages/WishingTree/pages/WishCardList'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/wishingtree/wishing_active_rule',
    title: '活动规则',
    toolName: '祈福',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "wishingActiveRule" */ 'pages/WishingTree/pages/ActiveRule'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/wishingtree/wishing_lucky_rule',
    title: '福气值规则',
    toolName: '祈福',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "wishingLuckyRule" */ 'pages/WishingTree/pages/LuckyRule'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/wishingtree/wishdetail',
    title: '心愿详情',
    toolName: '祈福',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "WishingTreeWishDetailPage" */ 'pages/WishingTree/pages/WishDetail'
      )
      )
    )
  },
  {
    path: '/h5_fe_tool/html/wishingtree/wishset',
    title: '祈福设置',
    toolName: '祈福',
    exact: true,
    component: Loadable(
      getComponent(() => import(
        /* webpackChunkName: "WishingTreeWishSetPage" */ 'pages/WishingTree/pages/WishSet'
      )
      )
    )
  },
  {
    path: '*',
    title: '抱歉，您访问的页面不存在！',
    component: require('core/Error/404').default
  }
];

export default routes;
